import { useState } from 'react';
import { useRemote } from '../../../Utils/Utils';
import { AlertCircle } from 'react-feather';
import Modal from '../../../components/Modals/Modal';


export const useUploadWithConfirmation = () => {
    const remote = useRemote();
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [batch, setBatch] = useState(null);
    const [lastBatchWithEncryptedFiles, setLastBatchWithEncryptedFiles] = useState(null);


    const ConfirmDialog = () => {
        if (!showConfirmDialog) return null;
        return (
            <Modal
                header="Upload during processing?"
                handleClose={handleClose}
                cancelButton={{
                    label: "No, cancel files upload",
                    variant: "danger",
                    noPadding: true,
                    onClick: handleCancelUpload,
                }}
                confirmButton={{
                    label: "Yes, continue",
                    variant: "positive",
                    onClick: handleConfirmUpload,
                }}
            >
                <p className='pb-m'>A Workflow is currently in progress. Uploading the files listed below will replace the previously uploaded files.</p>
                <p className='pb-m'>
                    <AlertCircle size={18} color={"#E66780"} style={{ transform: 'translateY(3px)', paddingRight: '0.25rem' }} />
                    <span style={{ fontWeight: 600 }}>Important:</span>
                    <span> Any existing approvals will be cancelled and you will need to restart the approval process.</span>
                </p>
                <p>Do you want to continue anyway?</p>
                <ul style={{ paddingTop: '1rem' }}>
                    {batch && batch.uploadedFiles && batch.uploadedFiles.filter(file => file.status === 'ON_HOLD').map((f, idx) => <li key={f.fileName + "-" + idx} style={{ lineHeight: 1.5 }}>{f.fileName}</li>)}
                </ul>
            </Modal>
        );
    };

    const checkBeforeUpload = (batch) => {
        setBatch(batch);
        setShowConfirmDialog(true);
    };

    const handleConfirmUpload = () => {
        remote.post(`/data/upload/resume/${batch.batchId}?confirm=true`).then(() => {
            setShowConfirmDialog(false);
            setBatch(null);
        })
    };

    const handleCancelUpload = () => {
        remote.post(`/data/upload/resume/${batch.batchId}?confirm=false`).then(() => {
            setShowConfirmDialog(false);
            setBatch(null);
        })
    };

    const handleClose = () => {
        setShowConfirmDialog(false);
    }

    return {
        showConfirmDialog,
        checkBeforeUpload,
        handleConfirmUpload,
        handleCancelUpload,
        ConfirmDialog,
        lastBatchWithEncryptedFiles,
        setLastBatchWithEncryptedFiles
    };
};